export default {"src":"/_next/static/media/email-share.75a48340.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};